// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as ShadcnShowcaseRouteImport } from './routes/shadcn-showcase'
import { Route as ReservationConfirmationRouteImport } from './routes/reservation-confirmation'
import { Route as MapDemoRouteImport } from './routes/map-demo'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WebdesignedIndexRouteImport } from './routes/webdesigned/index'
import { Route as StaffIndexRouteImport } from './routes/staff/index'
import { Route as ReceptionIndexRouteImport } from './routes/reception/index'
import { Route as ManagerIndexRouteImport } from './routes/manager/index'
import { Route as ClientIndexRouteImport } from './routes/client/index'
import { Route as AnalysisIndexRouteImport } from './routes/analysis/index'
import { Route as WebdesignedStaysRouteImport } from './routes/webdesigned/stays'
import { Route as WebdesignedGalleryRouteImport } from './routes/webdesigned/gallery'
import { Route as WebdesignedForfaitsRouteImport } from './routes/webdesigned/forfaits'
import { Route as WebdesignedActivitiesRouteImport } from './routes/webdesigned/activities'
import { Route as WebdesignedAccountRouteImport } from './routes/webdesigned/account'
import { Route as WebdesignedLayoutRouteImport } from './routes/webdesigned/_layout'
import { Route as StaffTasksRouteImport } from './routes/staff/tasks'
import { Route as StaffStaysRouteImport } from './routes/staff/stays'
import { Route as StaffSettingsRouteImport } from './routes/staff/settings'
import { Route as StaffRemindersRouteImport } from './routes/staff/reminders'
import { Route as StaffPromosRouteImport } from './routes/staff/promos'
import { Route as StaffOrdersRouteImport } from './routes/staff/orders'
import { Route as StaffMediaRouteImport } from './routes/staff/media'
import { Route as StaffBookingsRouteImport } from './routes/staff/bookings'
import { Route as StaffActivitiesRouteImport } from './routes/staff/activities'
import { Route as StaffLayoutRouteImport } from './routes/staff/_layout'
import { Route as ReceptionOrdersRouteImport } from './routes/reception/orders'
import { Route as ReceptionClientsRouteImport } from './routes/reception/clients'
import { Route as ReceptionLayoutRouteImport } from './routes/reception/_layout'
import { Route as PayTokenRouteImport } from './routes/pay.$token'
import { Route as ManagerWebRouteImport } from './routes/manager/web'
import { Route as ManagerStaysRouteImport } from './routes/manager/stays'
import { Route as ManagerSettingsRouteImport } from './routes/manager/settings'
import { Route as ManagerReportsRouteImport } from './routes/manager/reports'
import { Route as ManagerRemindersRouteImport } from './routes/manager/reminders'
import { Route as ManagerPromosRouteImport } from './routes/manager/promos'
import { Route as ManagerOrdersRouteImport } from './routes/manager/orders'
import { Route as ManagerMediaRouteImport } from './routes/manager/media'
import { Route as ManagerMarketingRouteImport } from './routes/manager/marketing'
import { Route as ManagerLoyaltyRouteImport } from './routes/manager/loyalty'
import { Route as ManagerFoodRouteImport } from './routes/manager/food'
import { Route as ManagerFinancialRouteImport } from './routes/manager/financial'
import { Route as ManagerEmployeesRouteImport } from './routes/manager/employees'
import { Route as ManagerDiscountsRouteImport } from './routes/manager/discounts'
import { Route as ManagerCrmRouteImport } from './routes/manager/crm'
import { Route as ManagerClientsRouteImport } from './routes/manager/clients'
import { Route as ManagerBundlesRouteImport } from './routes/manager/bundles'
import { Route as ManagerBookingsRouteImport } from './routes/manager/bookings'
import { Route as ManagerBoardRouteImport } from './routes/manager/board'
import { Route as ManagerActivitiesRouteImport } from './routes/manager/activities'
import { Route as ManagerLayoutRouteImport } from './routes/manager/_layout'
import { Route as ClientShopcartRouteImport } from './routes/client/shopcart'
import { Route as ClientSettingsRouteImport } from './routes/client/settings'
import { Route as ClientPointsRouteImport } from './routes/client/points'
import { Route as ClientOrdersRouteImport } from './routes/client/orders'
import { Route as ClientOffersRouteImport } from './routes/client/offers'
import { Route as ClientLayoutRouteImport } from './routes/client/_layout'
import { Route as AnalysisProcessRouteImport } from './routes/analysis/process'
import { Route as AnalysisLayoutRouteImport } from './routes/analysis/_layout'
import { Route as SignupVerifyPhoneNumberRouteImport } from './routes/signup/verify-phone-number'
import { Route as SignupVerifyEmailAddressRouteImport } from './routes/signup/verify-email-address'
import { Route as WebdesignedStaysIdRouteImport } from './routes/webdesigned/stays_.$id'
import { Route as WebdesignedForfaitsIdRouteImport } from './routes/webdesigned/forfaits_.$id'
import { Route as WebdesignedActivitiesIdRouteImport } from './routes/webdesigned/activities_.$id'
import { Route as StaffReservationsNewRouteImport } from './routes/staff.reservations.new'
import { Route as ReceptionReservationsNewRouteImport } from './routes/reception.reservations.new'
import { Route as ManagerReservationsNewRouteImport } from './routes/manager.reservations.new'
import { Route as StaffOrdersIndexRouteImport } from './routes/staff/orders/index'
import { Route as StaffOrdersNewRouteImport } from './routes/staff.orders.new'
import { Route as ReceptionOrdersIndexRouteImport } from './routes/reception/orders/index'
import { Route as ReceptionOrdersNewRouteImport } from './routes/reception.orders.new'
import { Route as ManagerOrdersIndexRouteImport } from './routes/manager/orders/index'
import { Route as ManagerOrdersNewRouteImport } from './routes/manager.orders.new'

const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SigninRoute = SigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => rootRouteImport
          })
const ShadcnShowcaseRoute = ShadcnShowcaseRouteImport.update({
            id: '/shadcn-showcase',path: '/shadcn-showcase',getParentRoute: () => rootRouteImport
          })
const ReservationConfirmationRoute = ReservationConfirmationRouteImport.update({
            id: '/reservation-confirmation',path: '/reservation-confirmation',getParentRoute: () => rootRouteImport
          })
const MapDemoRoute = MapDemoRouteImport.update({
            id: '/map-demo',path: '/map-demo',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LandingRoute = LandingRouteImport.update({
            id: '/landing',path: '/landing',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const WebdesignedIndexRoute = WebdesignedIndexRouteImport.update({
            id: '/webdesigned/',path: '/webdesigned/',getParentRoute: () => rootRouteImport
          })
const StaffIndexRoute = StaffIndexRouteImport.update({
            id: '/staff/',path: '/staff/',getParentRoute: () => rootRouteImport
          })
const ReceptionIndexRoute = ReceptionIndexRouteImport.update({
            id: '/reception/',path: '/reception/',getParentRoute: () => rootRouteImport
          })
const ManagerIndexRoute = ManagerIndexRouteImport.update({
            id: '/manager/',path: '/manager/',getParentRoute: () => rootRouteImport
          })
const ClientIndexRoute = ClientIndexRouteImport.update({
            id: '/client/',path: '/client/',getParentRoute: () => rootRouteImport
          })
const AnalysisIndexRoute = AnalysisIndexRouteImport.update({
            id: '/analysis/',path: '/analysis/',getParentRoute: () => rootRouteImport
          })
const WebdesignedStaysRoute = WebdesignedStaysRouteImport.update({
            id: '/webdesigned/stays',path: '/webdesigned/stays',getParentRoute: () => rootRouteImport
          })
const WebdesignedGalleryRoute = WebdesignedGalleryRouteImport.update({
            id: '/webdesigned/gallery',path: '/webdesigned/gallery',getParentRoute: () => rootRouteImport
          })
const WebdesignedForfaitsRoute = WebdesignedForfaitsRouteImport.update({
            id: '/webdesigned/forfaits',path: '/webdesigned/forfaits',getParentRoute: () => rootRouteImport
          })
const WebdesignedActivitiesRoute = WebdesignedActivitiesRouteImport.update({
            id: '/webdesigned/activities',path: '/webdesigned/activities',getParentRoute: () => rootRouteImport
          })
const WebdesignedAccountRoute = WebdesignedAccountRouteImport.update({
            id: '/webdesigned/account',path: '/webdesigned/account',getParentRoute: () => rootRouteImport
          })
const WebdesignedLayoutRoute = WebdesignedLayoutRouteImport.update({
            id: '/webdesigned/_layout',path: '/webdesigned',getParentRoute: () => rootRouteImport
          })
const StaffTasksRoute = StaffTasksRouteImport.update({
            id: '/staff/tasks',path: '/staff/tasks',getParentRoute: () => rootRouteImport
          })
const StaffStaysRoute = StaffStaysRouteImport.update({
            id: '/staff/stays',path: '/staff/stays',getParentRoute: () => rootRouteImport
          })
const StaffSettingsRoute = StaffSettingsRouteImport.update({
            id: '/staff/settings',path: '/staff/settings',getParentRoute: () => rootRouteImport
          })
const StaffRemindersRoute = StaffRemindersRouteImport.update({
            id: '/staff/reminders',path: '/staff/reminders',getParentRoute: () => rootRouteImport
          })
const StaffPromosRoute = StaffPromosRouteImport.update({
            id: '/staff/promos',path: '/staff/promos',getParentRoute: () => rootRouteImport
          })
const StaffOrdersRoute = StaffOrdersRouteImport.update({
            id: '/staff/orders',path: '/staff/orders',getParentRoute: () => rootRouteImport
          })
const StaffMediaRoute = StaffMediaRouteImport.update({
            id: '/staff/media',path: '/staff/media',getParentRoute: () => rootRouteImport
          })
const StaffBookingsRoute = StaffBookingsRouteImport.update({
            id: '/staff/bookings',path: '/staff/bookings',getParentRoute: () => rootRouteImport
          })
const StaffActivitiesRoute = StaffActivitiesRouteImport.update({
            id: '/staff/activities',path: '/staff/activities',getParentRoute: () => rootRouteImport
          })
const StaffLayoutRoute = StaffLayoutRouteImport.update({
            id: '/staff/_layout',path: '/staff',getParentRoute: () => rootRouteImport
          })
const ReceptionOrdersRoute = ReceptionOrdersRouteImport.update({
            id: '/reception/orders',path: '/reception/orders',getParentRoute: () => rootRouteImport
          })
const ReceptionClientsRoute = ReceptionClientsRouteImport.update({
            id: '/reception/clients',path: '/reception/clients',getParentRoute: () => rootRouteImport
          })
const ReceptionLayoutRoute = ReceptionLayoutRouteImport.update({
            id: '/reception/_layout',path: '/reception',getParentRoute: () => rootRouteImport
          })
const PayTokenRoute = PayTokenRouteImport.update({
            id: '/pay/$token',path: '/pay/$token',getParentRoute: () => rootRouteImport
          })
const ManagerWebRoute = ManagerWebRouteImport.update({
            id: '/manager/web',path: '/manager/web',getParentRoute: () => rootRouteImport
          })
const ManagerStaysRoute = ManagerStaysRouteImport.update({
            id: '/manager/stays',path: '/manager/stays',getParentRoute: () => rootRouteImport
          })
const ManagerSettingsRoute = ManagerSettingsRouteImport.update({
            id: '/manager/settings',path: '/manager/settings',getParentRoute: () => rootRouteImport
          })
const ManagerReportsRoute = ManagerReportsRouteImport.update({
            id: '/manager/reports',path: '/manager/reports',getParentRoute: () => rootRouteImport
          })
const ManagerRemindersRoute = ManagerRemindersRouteImport.update({
            id: '/manager/reminders',path: '/manager/reminders',getParentRoute: () => rootRouteImport
          })
const ManagerPromosRoute = ManagerPromosRouteImport.update({
            id: '/manager/promos',path: '/manager/promos',getParentRoute: () => rootRouteImport
          })
const ManagerOrdersRoute = ManagerOrdersRouteImport.update({
            id: '/manager/orders',path: '/manager/orders',getParentRoute: () => rootRouteImport
          })
const ManagerMediaRoute = ManagerMediaRouteImport.update({
            id: '/manager/media',path: '/manager/media',getParentRoute: () => rootRouteImport
          })
const ManagerMarketingRoute = ManagerMarketingRouteImport.update({
            id: '/manager/marketing',path: '/manager/marketing',getParentRoute: () => rootRouteImport
          })
const ManagerLoyaltyRoute = ManagerLoyaltyRouteImport.update({
            id: '/manager/loyalty',path: '/manager/loyalty',getParentRoute: () => rootRouteImport
          })
const ManagerFoodRoute = ManagerFoodRouteImport.update({
            id: '/manager/food',path: '/manager/food',getParentRoute: () => rootRouteImport
          })
const ManagerFinancialRoute = ManagerFinancialRouteImport.update({
            id: '/manager/financial',path: '/manager/financial',getParentRoute: () => rootRouteImport
          })
const ManagerEmployeesRoute = ManagerEmployeesRouteImport.update({
            id: '/manager/employees',path: '/manager/employees',getParentRoute: () => rootRouteImport
          })
const ManagerDiscountsRoute = ManagerDiscountsRouteImport.update({
            id: '/manager/discounts',path: '/manager/discounts',getParentRoute: () => rootRouteImport
          })
const ManagerCrmRoute = ManagerCrmRouteImport.update({
            id: '/manager/crm',path: '/manager/crm',getParentRoute: () => rootRouteImport
          })
const ManagerClientsRoute = ManagerClientsRouteImport.update({
            id: '/manager/clients',path: '/manager/clients',getParentRoute: () => rootRouteImport
          })
const ManagerBundlesRoute = ManagerBundlesRouteImport.update({
            id: '/manager/bundles',path: '/manager/bundles',getParentRoute: () => rootRouteImport
          })
const ManagerBookingsRoute = ManagerBookingsRouteImport.update({
            id: '/manager/bookings',path: '/manager/bookings',getParentRoute: () => rootRouteImport
          })
const ManagerBoardRoute = ManagerBoardRouteImport.update({
            id: '/manager/board',path: '/manager/board',getParentRoute: () => rootRouteImport
          })
const ManagerActivitiesRoute = ManagerActivitiesRouteImport.update({
            id: '/manager/activities',path: '/manager/activities',getParentRoute: () => rootRouteImport
          })
const ManagerLayoutRoute = ManagerLayoutRouteImport.update({
            id: '/manager/_layout',path: '/manager',getParentRoute: () => rootRouteImport
          })
const ClientShopcartRoute = ClientShopcartRouteImport.update({
            id: '/client/shopcart',path: '/client/shopcart',getParentRoute: () => rootRouteImport
          })
const ClientSettingsRoute = ClientSettingsRouteImport.update({
            id: '/client/settings',path: '/client/settings',getParentRoute: () => rootRouteImport
          })
const ClientPointsRoute = ClientPointsRouteImport.update({
            id: '/client/points',path: '/client/points',getParentRoute: () => rootRouteImport
          })
const ClientOrdersRoute = ClientOrdersRouteImport.update({
            id: '/client/orders',path: '/client/orders',getParentRoute: () => rootRouteImport
          })
const ClientOffersRoute = ClientOffersRouteImport.update({
            id: '/client/offers',path: '/client/offers',getParentRoute: () => rootRouteImport
          })
const ClientLayoutRoute = ClientLayoutRouteImport.update({
            id: '/client/_layout',path: '/client',getParentRoute: () => rootRouteImport
          })
const AnalysisProcessRoute = AnalysisProcessRouteImport.update({
            id: '/analysis/process',path: '/analysis/process',getParentRoute: () => rootRouteImport
          })
const AnalysisLayoutRoute = AnalysisLayoutRouteImport.update({
            id: '/analysis/_layout',path: '/analysis',getParentRoute: () => rootRouteImport
          })
const SignupVerifyPhoneNumberRoute = SignupVerifyPhoneNumberRouteImport.update({
            id: '/verify-phone-number',path: '/verify-phone-number',getParentRoute: () => SignupRoute
          })
const SignupVerifyEmailAddressRoute = SignupVerifyEmailAddressRouteImport.update({
            id: '/verify-email-address',path: '/verify-email-address',getParentRoute: () => SignupRoute
          })
const WebdesignedStaysIdRoute = WebdesignedStaysIdRouteImport.update({
            id: '/webdesigned/stays_/$id',path: '/webdesigned/stays/$id',getParentRoute: () => rootRouteImport
          })
const WebdesignedForfaitsIdRoute = WebdesignedForfaitsIdRouteImport.update({
            id: '/webdesigned/forfaits_/$id',path: '/webdesigned/forfaits/$id',getParentRoute: () => rootRouteImport
          })
const WebdesignedActivitiesIdRoute = WebdesignedActivitiesIdRouteImport.update({
            id: '/webdesigned/activities_/$id',path: '/webdesigned/activities/$id',getParentRoute: () => rootRouteImport
          })
const StaffReservationsNewRoute = StaffReservationsNewRouteImport.update({
            id: '/staff/reservations/new',path: '/staff/reservations/new',getParentRoute: () => rootRouteImport
          })
const ReceptionReservationsNewRoute = ReceptionReservationsNewRouteImport.update({
            id: '/reception/reservations/new',path: '/reception/reservations/new',getParentRoute: () => rootRouteImport
          })
const ManagerReservationsNewRoute = ManagerReservationsNewRouteImport.update({
            id: '/manager/reservations/new',path: '/manager/reservations/new',getParentRoute: () => rootRouteImport
          })
const StaffOrdersIndexRoute = StaffOrdersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => StaffOrdersRoute
          })
const StaffOrdersNewRoute = StaffOrdersNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => StaffOrdersRoute
          })
const ReceptionOrdersIndexRoute = ReceptionOrdersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ReceptionOrdersRoute
          })
const ReceptionOrdersNewRoute = ReceptionOrdersNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => ReceptionOrdersRoute
          })
const ManagerOrdersIndexRoute = ManagerOrdersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ManagerOrdersRoute
          })
const ManagerOrdersNewRoute = ManagerOrdersNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => ManagerOrdersRoute
          })





const SignupRouteChildren = {
  SignupVerifyEmailAddressRoute: SignupVerifyEmailAddressRoute,SignupVerifyPhoneNumberRoute: SignupVerifyPhoneNumberRoute
}

const SignupRouteWithChildren = SignupRoute._addFileChildren(SignupRouteChildren)




const ManagerOrdersRouteChildren = {
  ManagerOrdersNewRoute: ManagerOrdersNewRoute,ManagerOrdersIndexRoute: ManagerOrdersIndexRoute
}

const ManagerOrdersRouteWithChildren = ManagerOrdersRoute._addFileChildren(ManagerOrdersRouteChildren)




const ReceptionOrdersRouteChildren = {
  ReceptionOrdersNewRoute: ReceptionOrdersNewRoute,ReceptionOrdersIndexRoute: ReceptionOrdersIndexRoute
}

const ReceptionOrdersRouteWithChildren = ReceptionOrdersRoute._addFileChildren(ReceptionOrdersRouteChildren)




const StaffOrdersRouteChildren = {
  StaffOrdersNewRoute: StaffOrdersNewRoute,StaffOrdersIndexRoute: StaffOrdersIndexRoute
}

const StaffOrdersRouteWithChildren = StaffOrdersRoute._addFileChildren(StaffOrdersRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,DemoRoute: DemoRoute,ForgotPasswordRoute: ForgotPasswordRoute,LandingRoute: LandingRoute,LoginRoute: LoginRoute,MapDemoRoute: MapDemoRoute,ReservationConfirmationRoute: ReservationConfirmationRoute,ShadcnShowcaseRoute: ShadcnShowcaseRoute,SigninRoute: SigninRoute,SignupRoute: SignupRouteWithChildren,AnalysisLayoutRoute: AnalysisLayoutRoute,AnalysisProcessRoute: AnalysisProcessRoute,ClientLayoutRoute: ClientLayoutRoute,ClientOffersRoute: ClientOffersRoute,ClientOrdersRoute: ClientOrdersRoute,ClientPointsRoute: ClientPointsRoute,ClientSettingsRoute: ClientSettingsRoute,ClientShopcartRoute: ClientShopcartRoute,ManagerLayoutRoute: ManagerLayoutRoute,ManagerActivitiesRoute: ManagerActivitiesRoute,ManagerBoardRoute: ManagerBoardRoute,ManagerBookingsRoute: ManagerBookingsRoute,ManagerBundlesRoute: ManagerBundlesRoute,ManagerClientsRoute: ManagerClientsRoute,ManagerCrmRoute: ManagerCrmRoute,ManagerDiscountsRoute: ManagerDiscountsRoute,ManagerEmployeesRoute: ManagerEmployeesRoute,ManagerFinancialRoute: ManagerFinancialRoute,ManagerFoodRoute: ManagerFoodRoute,ManagerLoyaltyRoute: ManagerLoyaltyRoute,ManagerMarketingRoute: ManagerMarketingRoute,ManagerMediaRoute: ManagerMediaRoute,ManagerOrdersRoute: ManagerOrdersRouteWithChildren,ManagerPromosRoute: ManagerPromosRoute,ManagerRemindersRoute: ManagerRemindersRoute,ManagerReportsRoute: ManagerReportsRoute,ManagerSettingsRoute: ManagerSettingsRoute,ManagerStaysRoute: ManagerStaysRoute,ManagerWebRoute: ManagerWebRoute,PayTokenRoute: PayTokenRoute,ReceptionLayoutRoute: ReceptionLayoutRoute,ReceptionClientsRoute: ReceptionClientsRoute,ReceptionOrdersRoute: ReceptionOrdersRouteWithChildren,StaffLayoutRoute: StaffLayoutRoute,StaffActivitiesRoute: StaffActivitiesRoute,StaffBookingsRoute: StaffBookingsRoute,StaffMediaRoute: StaffMediaRoute,StaffOrdersRoute: StaffOrdersRouteWithChildren,StaffPromosRoute: StaffPromosRoute,StaffRemindersRoute: StaffRemindersRoute,StaffSettingsRoute: StaffSettingsRoute,StaffStaysRoute: StaffStaysRoute,StaffTasksRoute: StaffTasksRoute,WebdesignedLayoutRoute: WebdesignedLayoutRoute,WebdesignedAccountRoute: WebdesignedAccountRoute,WebdesignedActivitiesRoute: WebdesignedActivitiesRoute,WebdesignedForfaitsRoute: WebdesignedForfaitsRoute,WebdesignedGalleryRoute: WebdesignedGalleryRoute,WebdesignedStaysRoute: WebdesignedStaysRoute,AnalysisIndexRoute: AnalysisIndexRoute,ClientIndexRoute: ClientIndexRoute,ManagerIndexRoute: ManagerIndexRoute,ReceptionIndexRoute: ReceptionIndexRoute,StaffIndexRoute: StaffIndexRoute,WebdesignedIndexRoute: WebdesignedIndexRoute,ManagerReservationsNewRoute: ManagerReservationsNewRoute,ReceptionReservationsNewRoute: ReceptionReservationsNewRoute,StaffReservationsNewRoute: StaffReservationsNewRoute,WebdesignedActivitiesIdRoute: WebdesignedActivitiesIdRoute,WebdesignedForfaitsIdRoute: WebdesignedForfaitsIdRoute,WebdesignedStaysIdRoute: WebdesignedStaysIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)